module.exports = __webpack_public_path__ + "img/horcrux-tom-riddle.e19fea15.png";